import { features } from "@/mocks/home";

export default function Features() {
  return (
    <section id="features" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700">
            <i className="ri-sparkling-line"></i>
            核心特色
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            围绕观看体验梳理的六项能力
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            从找片、播放到离线保存，茶杯狐影视把在线观看、免费观看、高清播放、下载、缓存与无广告观看
            放在同一条体验链路里。下面把每一项拆开说明，方便你按自己的习惯选择。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((item) => (
            <article
              key={item.id}
              className="group rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300 hover:bg-primary-50/60"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}